import { HARISENIN_NEW_PUBLIC_IMAGE } from "@constants/const/pictures"

export const VALUE_LIST = [
  {
    image_web: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_desktop_1.webp`,
    image_mobile: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_mobile_1.webp`,
    title: "Workventure Experience",
    subCopy:
      "Fokus pada pengalaman kerja nyata lewat misi seru ala game. Selesaikan misi lebih cepat, lulus lebih cepat!",
  },
  {
    image_web: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_desktop_2.webp`,
    image_mobile: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_mobile_2.webp`,
    title: "Fokus Spesialisasi",
    subCopy:
      "Bebas pilih spesialisasi! Belajar lebih efisien di bidang yang kamu mau tanpa buang waktu untuk materi yang tidak relevan.",
  },
  {
    image_web: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_desktop_3.webp`,
    image_mobile: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_mobile_3.webp`,
    title: "AI-Powered Curriculum",
    subCopy:
      "Menggunakan tool AI dalam alur kerja harian. Lulus dengan standar industri & efisiensi tinggi untuk karier masa kini!",
  },
  {
    image_web: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_desktop_4.webp`,
    image_mobile: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_mobile_4.webp`,
    title: "Personalized Career Service",
    subCopy:
      "Bantuan karier personal untuk tiap individu. Strategi agar kamu raih pekerjaan impian secara lebih cepat dan efektif!",
  },
  {
    image_web: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_desktop_5.webp`,
    image_mobile: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_mobile_5.webp`,
    title: "24/7 Personal Mentor",
    subCopy:
      "Bebas tanya ke personal mentor kapan pun dan di mana pun. Dukungan penuh di luar jam kelas agar belajarmu tanpa hambatan!",
  },
  {
    image_web: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_desktop_6.webp`,
    image_mobile: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_mobile_6.webp`,
    title: "Lebih Cepat Balik Modal",
    subCopy:
      "Cukup 1 bulan gaji, balik modal 2-5x! Lebih aman dengan jaminan refund hingga 110%, angka tertinggi di industri saat ini.",
  },
  {
    image_web: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_desktop_7.webp`,
    image_mobile: `${HARISENIN_NEW_PUBLIC_IMAGE}/homepage_experience_mobile_7.webp`,
    title: "Mental Health Matters",
    subCopy:
      "Tak hanya asah skill, kami peduli kesehatan mentalmu. Jadi alumni yang siap terjun ke dunia kerja dengan mental tangguh!",
  },
]
